<template>
  <vs-popup title="Selecione o modelo de mensagem para ser enviado" :active.sync="opened" v-on:close="onFinalizeModalClose" class="sizePopup">
    <count-message-template :instance="instance" ></count-message-template>

    <div class="w-full">
      <select-message-template
          :itemsPerPage="6"
          :instance="instance"
          ref="select-message-template"
          title="Selecione Modelo de Mensagens"
          @on-select-template="selectTemplate"
          :contact-name="customerName"
          @sendMessageTemplate="sendMessageTemplate()"
      ></select-message-template>
    </div>
  </vs-popup>
</template>

<script>

import metaMessageTemplateApi from '@/http/requests/metaMessageTemplate'
import CountMessageTemplate from "@/components/meta/CountMessageTemplate.vue";
import selectMessageTemplate from "@/components/meta/SelectMessageTemplate.vue";

export default {
  name: 'meta-message-template-popup',
  props: {
    instance:{
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      required: true
    },
    toNumber: {
      type: String,
      required: true
    },
    customerName: {
      type: String,
      required: true
    },
    closeCallback: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      submitData: false,
      selectedTemplateMessage: [],
      templateMessageParameters: [],
      customer: null
    }
  },
  provide() {
    return {
      $validator: this.$validator,
    }
  },
  watch: {
    opened(val) {
      if (val) {
        this.$refs['select-message-template'].cleanData(true)
      }
    },
    submitData(val) {
      if (val) {
        setTimeout(() => {
          this.submitData = false;
        }, 3000);
      }
    }
  },
  methods: {
    onFinalizeModalClose() {
      this.selectedTemplateMessage = []
      this.templateMessageParameters = []
      this.$refs['select-message-template'].cleanData(true)
      this.closeCallback();
    },
    selectTemplate(args){
      this.selectedTemplateMessage = args.selectedTemplate
      this.templateMessageParameters = args.templateParameters
    },
    async validade(){
      if (
          !this.instance.messaging_limit.includes('UNLIMITED')
          && Number(this.instance.messaging_send) >= Number(this.instance.messaging_limit)
      ) {
        return this.$vs.notify({
          time: 8000,
          color: "danger",
          title: "Limite de Atendimentos Iniciados Ativamente Atingido!",
          text: "Você não pode iniciar novos atendimentos porque o Limite Diário de abertura ativamente foi atingido."
        })
      }

      let childs = this.$children.map( async child => {
        return await child.$validator.validateAll();
      });

      childs = await Promise.all(childs).then( results => { return results; });
      return !childs.includes(false);
    },
    isInboxAttended() {
      const isInboxAttended = this.$store.state.customer.customers.items;

      isInboxAttended.forEach(customer => {
        if (customer.phone_number === this.toNumber) {
          this.customer = customer
        }
      })

      const isBeingAttendedBy = this.customer ? this.customer.isBeingAttendedBy[0] : null

      if (isBeingAttendedBy && isBeingAttendedBy.user_id === null 
        && this.$store.getters["instance/chosenInstanceIds"].includes(this.customer.isBeingAttendedBy[0].instance_id)
      ) {
        return true;
      }

    },
    async sendMessageTemplate() {
      if (this.isInboxAttended()) {
        this.$vs.notify({
          color: 'warning',
          title: 'Atenção!',
          text: `Este atendimento está aberto na caixa de entrada`,
          time: 5000
        })

        return;
      }

      if (await this.validade()) {
        this.submitData = true;
        const data = {
          to_number: this.toNumber,
          instance_id: this.instance.id,
          user_id: this.$store.state.AppActiveUser.id,
          official_params: this.templateMessageParameters,
          message_template_name: this.selectedTemplateMessage.name,
        }

        await metaMessageTemplateApi.send(data)
        this.$emit('on-success', this.toNumber);
      }
    }
  },
  components: {
    CountMessageTemplate,
    selectMessageTemplate
  }
};
</script>
